<!-- Compact button variation used for input field appends/prepends -->
<template>
    <q-btn
        color="input"
        text-color="input"
        no-caps
        size="sm"
        padding="4px"
        type="button"
    >
        <template v-for="(_, slot) in $slots" #[slot]="scope">
            <slot :name="slot" v-bind="{...scope}" />
        </template>
    </q-btn>
</template>
